module.exports = __webpack_public_path__ + "static/media/soash_delama__kauffman_mcclellan.0fca5dc5.jpg";